<template>
    <a
        @click="goToLink"
        :class="is_active ? 'text-black px-4' : 'text-black px-4'"
        style="border: 0px !important;"
    >
<!--        to remove the blue and '(NEW)' text, clear the created at date in the database for the smartnav record. OR change the created at date in the db, or update the code for the created at great than in the computer below -->
        <div
            :class="is_active ? 'text-black' : 'text-black'"
            class="lg:text-link-menu"
            :style="is_new_menu_item ? 'color: blue': ''"
        >
            {{ link_display_name }} {{is_new_menu_item ? '(NEW)': ''}}
        </div>
    </a>
</template>

<script>
export default {
    name: "SmartNavSidebarItem",
    props: {
        'input': {
            type: Object,
            required: true,
        },
        // The parent object listens for partial page loads from Inertia, and so can update this prop accordingly
        'selected': {
            type: Boolean,
            required: false,
            default: function () {
                return false
            }
        },
        // The parent object listens for partial page loads from Inertia, and so can update this prop accordingly
        'current_route': {
            type: String,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            searchTree: (fn) => (obj) =>
                Array.isArray(obj)
                    ? obj.length == 0
                        ? null
                        : this.searchTree (fn) (obj [0]) || this.searchTree (fn) (obj .slice (1))
                    : fn (
                        obj,
                        () => this.searchTree (fn) (obj .children || []),
                        () => obj
                    ),
        }
    },
    mounted() {
        //
    },
    computed: {
        // Indicates active status after a deep scan of this menu item and any children it might have (recursive)
        is_active() {
            let found_in_child_routes = !!(this.findRouteName(this.current_route))
            let result = this.selected || found_in_child_routes
            if (result) {
                this.$emit('selection')
            }
            return result
        },
        // In case we need a different indicator when this isn't the active item, but one of its descendants is (recursive)
        is_submenu_active() {
            let found_in_child_routes = !!(this.findRouteName(this.current_route))
            return found_in_child_routes && !this.selected
        },
        // A display-formatter for the name
        link_display_name() {
            // let prefix = this.is_submenu_active ? 'Back to ' : ''
            return `${this.input.name}`
        },
        // A display-formatter for the icon
        link_display_icon() {
            return this.input?.name_icon ? `mdi-${this.input.name_icon}` : ''
        },
        is_new_menu_item(){
            return this.input.created_at >  '2024-04-18 04:00:00' ? 1 : 0
        }
    },
    methods: {
        // Better than a standard a href since this will use Inertia to only load the part of the page that's required
        goToLink() {
            // if (this.$root.is_dirty) {
            //     // Make sure that user has a chance to stay put prior to navigating away
            //     window.location.href = route(this.input?.name_route)
            // }
            try {
                if (!route().check(this.input?.name_route)) {
                    throw "That page is still under construction"
                }

                this.$inertia.visit(route(this.input?.name_route), {
                    method: 'get',
                    data: {},
                    replace: false,
                    preserveState: true,
                    preserveScroll: true,
                    only: [],
                    headers: {},
                    onCancelToken: cancelToken => {
                    },
                    onCancel: () => {
                    },
                    onStart: visit => {
                    },
                    onProgress: progress => {
                    },
                    onSuccess: page => {
                    },
                    onFinish: () => {
                        this.$emit('selection_made')
                    },
                })
            } catch ($ex) {
                console.error($ex)
                this.$root.snackbar.error($ex)
            }

        },
        // Search recursively for an id through haystack+children...
        findId(target) {
            return this.searchTree (
                (node, next, found) => node.id === target ? found () : next(),
            ) (this.input)
        },
        // Search recursively for a route by name through haystack+children...
        findRouteName(target) {
            return this.searchTree (
                (node, next, found) => node.name_route === target ? found () : next(),
            ) (this.input)
        },
    },
}
</script>

<style scoped>
.active-nav-link {
    /*color: #123456;*/
}
</style>
